module.exports = __webpack_public_path__ + "static/media/Khadija.a3af0670.jpg";